import { Link } from '@mui/material'
import Box from '@mui/material/Box'
import { LuneTheme, Text } from 'lune-ui-lib'
import React from 'react'

import FrameLayout from 'components/FrameLayout'

const gradientBg = require('images/gradientBg.png')

const PageNotFound = () => {
    return (
        <FrameLayout>
            <Box
                sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'stretch',
                    p: 2,
                    pt: 0,
                    a: {
                        textDecoration: 'none !important',
                    },
                }}
            >
                <Box
                    sx={{
                        p: 6,
                        width: '100%',
                        flex: '1 1 auto',
                        borderRadius: '32px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundImage: `url(${gradientBg})`,
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                    }}
                >
                    <Box>
                        <Text variant={'h4'}>Oh boy...</Text>
                        <Text variant={'h4'} sx={{ mb: 4 }}>
                            Something went wrong.
                        </Text>
                        <Text variant={'body2'} sx={{ mb: 4 }}>
                            <Link
                                href="mailto:support@lune.co"
                                target="_blank"
                                sx={{
                                    color: LuneTheme.palette.Black,
                                    '&:hover': {
                                        textDecoration: 'underline !important',
                                    },
                                }}
                            >
                                Please contact support for help.
                            </Link>
                        </Text>
                    </Box>
                </Box>
            </Box>
        </FrameLayout>
    )
}

export default PageNotFound
